module.exports = __webpack_public_path__ + "img/142.6.108ec095.png";